import { useLocation } from "react-router-dom";
import { getExperienceParams } from "../utils/experienceContext";
import { setCookie } from "../utils/setCookie";

export const jtrCookieName = "jtr";
export const customRedirectCookieName = "custom_redirect_url";

export const useSsoRedirect = (jumpToResult = true, customRedirectUrl = null) => {
  const { search } = useLocation();

  return (cid) => {
    const searchParams = new URLSearchParams(search);
    const queryParams = searchParams.toString();
    const { expId } = getExperienceParams();
    const apiUrl = expId
      ? `/api/v1/web/marriott-passions-v3/login?expId=${encodeURIComponent(expId)}`
      : "/api/v1/web/marriott-passions-v3/login";
    setCookie("passions_campaign", queryParams, 10);

    if (jumpToResult) {
      setCookie(jtrCookieName, cid || 0, 10);
    }

    // Set custom redirect URL if provided
    if (customRedirectUrl) {
      setCookie(customRedirectCookieName, customRedirectUrl, 10);
    }

    window.location.href = apiUrl;
  };
};
